import React from 'react';
export function MenuUpIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.005a1 1 0 01-.709-1.7l2.991-3.01a1 1 0 011.414 0l3.009 2.99A1 1 0 1114.3 13.7L12 11.41l-2.286 2.3a.999.999 0 01-.714.295z"
  }));
}